module.exports = __webpack_public_path__ + "static/media/pr-bhansode.22613c20.png";